export default __webpack_public_path__ + "static/media/settings_room_device_doorbell.9d8a4e63.svg";